import { DataGridTemplate } from "../../../../shared/data-grid/data-grid.template";
import { RequestDetailService } from "./detail.service";

export class LocationApprovalMatrixPrintView extends DataGridTemplate {
    private request;
    constructor(
        private readonly detailService: RequestDetailService,
    ) {
        super();
        this.controls.add = false;
        this.controls.edit = false;
        this.controls.delete = false;
        this.controls.excel = false;
        this.pageable = false;
        this.sortable = false;
        this.title = 'Location Approvals'

        this.detailService.requestDetail
            .subscribe(x => {
                this.request = x;
                this.refresh();
            });
    }
    columns: any[] = [
        {
            field: 'Title',
            title: 'Title',
        },
        {
            field: 'Status',
            title: 'Status',
        },
        {
            field: 'TMName',
            title: 'TM',
        },
        {
            field: 'ApprovalDate',
            title: 'Approval Date'
        },
    ];

    read(opts: any): Promise<any> {
        return Promise.resolve(this.detailService.partApprovalData.value.LocationApprovals);
    }
    create(parentEditDataItem: any): void {
        return null;
    }
    edit(dataItem: any): void {
        return null;
    }
    save(dataItem: any, isNew: boolean): Promise<any> {
        return Promise.resolve();
    }
    delete(dataItem: any): Promise<any> {
        return Promise.resolve();
    }
    editForm: null;
}
